const sidebarWidth = 250

export const content = {
  paddingLeft: sidebarWidth + 40,
  paddingRight: 40,
  paddingTop: 70,
  width: '100%',
}
